import { LoadingSpinner } from '@/components/LoadingSpinner.tsx'
import { RecentReleases } from '@/components/analytics/RecentReleases'
import { RejectionRate } from '@/components/analytics/RejectionRate.tsx'
import { StoriesAccepted } from '@/components/analytics/StoriesAccepted.tsx'
import { StoryCycleTimeOverview } from '@/components/analytics/StoryCycleTimeOverview.tsx'
import { VelocityAndPointsAccepted } from '@/components/analytics/VelocityAndPointsAccepted.tsx'
import { VolatilityDetails } from '@/components/analytics/VolatilityDetails.tsx'
import { Separator } from '@/components/ui/separator.tsx'
import { STORY_STATUSES } from '@/constants/STORY_STATUSES.ts'
import { useUserContext } from '@/contexts/UserContext.tsx'
import { useQueryAnalyticsIterations, useQueryAnalyticsReleaseFlags } from '@/requests/queries/useQueryAnalytics.tsx'

export const ProjectAnalyticsPage = () => {
  const { apiKey } = useUserContext()

  const { loading: loadingIterations } = useQueryAnalyticsIterations(apiKey)
  const { loading: loadingAcceptedReleases } = useQueryAnalyticsReleaseFlags(apiKey, STORY_STATUSES.ACCEPTED)
  const { loading: loadingUnstartedReleases } = useQueryAnalyticsReleaseFlags(apiKey, STORY_STATUSES.UNSTARTED)

  if (loadingIterations || loadingAcceptedReleases || loadingUnstartedReleases) {
    return (
      <div className="flex justify-center items-center w-[calc(100vw-178px)] h-full z-10">
        <LoadingSpinner />
      </div>
    )
  }

  return (
    <>
      <h1 className="font-EN-KR-heading3-bold text-contents-primary">Project Overview</h1>
      <Separator className="mt-2.5 mb-4 bg-border-default-secondary" />
      <div className="flex flex-col gap-4">
        <p className="font-EN-KR-body2-regular text-contents-tertiary">
          Weekends removed. Time based on your project time zone.
        </p>
        <div className="grid grid-cols-2 gap-4">
          <VelocityAndPointsAccepted />
          <VolatilityDetails />
          <StoryCycleTimeOverview />
          <StoriesAccepted />
          <RejectionRate />
        </div>
        <RecentReleases />
      </div>
    </>
  )
}
